import { BrowserRouter as Router, Routes, Route } from 'react-router'

import InvoicesList from './components/InvoicesList'
import InvoiceShow from './components/InvoiceShow'

import GettingStarted from './GettingStarted'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import reactQueryConfig from 'reactQueryConfig'
import InvoiceCreate from './components/InvoiceCreate'
import InvoiceEdit from './components/InvoiceEdit'
import { ToastProvider } from './contexts/ToastContext'
import './App.css'

const queryClient = new QueryClient(reactQueryConfig)

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ToastProvider>
        <div className="px-5">
          <GettingStarted />
          <Router>
            <Routes>
              <Route path="/invoices/new" Component={InvoiceCreate} />
              <Route path="/invoices/:id" Component={InvoiceShow} />
              <Route path="/invoices/:id/edit" Component={InvoiceEdit} />
              <Route path="/" Component={InvoicesList} />
            </Routes>
          </Router>
        </div>
      </ToastProvider>
    </QueryClientProvider>
  )
}

export default App
